export const apiErrorMessage = (error: unknown, fallback = 'Request failed'): string => {
  const data = (error as { response?: { data?: unknown } } | null)?.response?.data;
  const messages = (value: unknown): string[] => {
    if (typeof value === 'string') return [value];
    if (Array.isArray(value)) return value.flatMap(messages);
    if (value && typeof value === 'object') return Object.values(value).flatMap(messages);
    return [];
  };
  return messages(data).join(' ') || (error instanceof Error ? error.message : fallback);
};
